<div style="padding: 20px 24px; min-width: 420px; max-width: 640px;">
  <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px;">
    <h2 style="margin: 0; font-size: 1.1rem; color: #1e5a3f; font-weight: 700;">
      Diagnóstico de conexión Vita
    </h2>
    <button type="button" (click)="close()"
      style="border: none; background: transparent; color: #9ca3af; cursor: pointer; display: inline-flex;">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Ambiente y URL -->
  <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 10px; padding: 14px; margin-bottom: 14px;">
    <div style="display: grid; grid-template-columns: 140px 1fr; gap: 8px 12px; font-size: 0.85rem;">
      <div style="color: #6b7280; font-weight: 600;">Ambiente</div>
      <div>
        <span [style.background]="isProd ? '#dcfce7' : '#fef3c7'"
              [style.color]="isProd ? '#15803d' : '#a16207'"
              style="padding: 3px 10px; border-radius: 999px; font-weight: 700; font-size: 0.78rem; text-transform: uppercase;">
          {{ data.environment || 'desconocido' }}
        </span>
      </div>

      <div style="color: #6b7280; font-weight: 600;">Base URL</div>
      <div style="color: #111827; font-family: monospace; font-size: 0.8rem; word-break: break-all;">
        {{ data.baseUrl }}
      </div>

      <div style="color: #6b7280; font-weight: 600;">xLogin</div>
      <div style="color: #111827; font-family: monospace; font-size: 0.8rem;">
        {{ data.xLoginFingerprint || '—' }}
      </div>

      <div style="color: #6b7280; font-weight: 600;">Consulta</div>
      <div style="color: #111827; font-size: 0.8rem;">
        {{ data.fetchedAt | date: 'yyyy-MM-dd HH:mm:ss' }}
      </div>
    </div>
  </div>

  <!-- Errores (si los hay) -->
  <div *ngIf="hasErrors"
    style="background: #fee2e2; border: 1px solid #fca5a5; border-radius: 10px; padding: 12px; margin-bottom: 14px;">
    <div style="font-weight: 700; color: #991b1b; font-size: 0.85rem; margin-bottom: 6px;">
      Errores detectados
    </div>
    <ul style="margin: 0; padding-left: 20px; color: #7f1d1d; font-size: 0.8rem;">
      <li *ngFor="let e of data.errors">{{ e }}</li>
    </ul>
  </div>

  <!-- /prices -->
  <div *ngIf="data.prices"
    style="border: 1px solid #e5e7eb; border-radius: 10px; padding: 14px; margin-bottom: 14px;">
    <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
      <span style="font-weight: 700; color: #111827; font-size: 0.9rem;">/prices</span>
      <span [style.background]="data.prices.reachable ? '#dcfce7' : '#fee2e2'"
            [style.color]="data.prices.reachable ? '#15803d' : '#991b1b'"
            style="padding: 2px 8px; border-radius: 999px; font-size: 0.72rem; font-weight: 700;">
        {{ data.prices.reachable ? 'OK' : 'ERROR' }}
      </span>
      <span style="color: #6b7280; font-size: 0.8rem;">
        · {{ data.prices.variantCount }} variantes · válido hasta {{ data.prices.validUntil || '—' }}
      </span>
    </div>

    <!-- Flags Colombia -->
    <div style="display: flex; gap: 8px; margin-bottom: 10px; flex-wrap: wrap;">
      <span [style.background]="data.prices.hasCO ? '#dcfce7' : '#e5e7eb'"
            [style.color]="data.prices.hasCO ? '#15803d' : '#6b7280'"
            style="padding: 4px 10px; border-radius: 8px; font-size: 0.75rem; font-weight: 600;">
        CO (ACH): {{ data.prices.hasCO ? 'SÍ' : 'NO' }}
      </span>
      <span [style.background]="data.prices.hasCOBREB ? '#dcfce7' : '#e5e7eb'"
            [style.color]="data.prices.hasCOBREB ? '#15803d' : '#6b7280'"
            style="padding: 4px 10px; border-radius: 8px; font-size: 0.75rem; font-weight: 600;">
        COBREB: {{ data.prices.hasCOBREB ? 'SÍ' : 'NO' }}
      </span>
      <span [style.background]="data.prices.hasCOCOP ? '#fef3c7' : '#e5e7eb'"
            [style.color]="data.prices.hasCOCOP ? '#a16207' : '#6b7280'"
            style="padding: 4px 10px; border-radius: 8px; font-size: 0.75rem; font-weight: 600;"
            title="COCOP fue deprecado por Vita — si aparece SÍ, avisar al equipo">
        COCOP: {{ data.prices.hasCOCOP ? 'SÍ (⚠)' : 'NO' }}
      </span>
    </div>

    <div style="font-size: 0.78rem; color: #4b5563; font-family: monospace; line-height: 1.7; word-break: break-word;">
      {{ priceVariantsSorted.join(', ') }}
    </div>
  </div>

  <!-- /withdrawal_rules -->
  <div *ngIf="data.rules"
    style="border: 1px solid #e5e7eb; border-radius: 10px; padding: 14px; margin-bottom: 14px;">
    <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
      <span style="font-weight: 700; color: #111827; font-size: 0.9rem;">/withdrawal_rules</span>
      <span [style.background]="data.rules.reachable ? '#dcfce7' : '#fee2e2'"
            [style.color]="data.rules.reachable ? '#15803d' : '#991b1b'"
            style="padding: 2px 8px; border-radius: 999px; font-size: 0.72rem; font-weight: 700;">
        {{ data.rules.reachable ? 'OK' : 'ERROR' }}
      </span>
      <span style="color: #6b7280; font-size: 0.8rem;">
        · {{ data.rules.variantCount }} variantes con reglas
      </span>
    </div>

    <div style="font-size: 0.78rem; color: #4b5563; font-family: monospace; line-height: 1.7; word-break: break-word;">
      {{ ruleVariantsSorted.join(', ') }}
    </div>
  </div>

  <div style="display: flex; justify-content: flex-end; margin-top: 16px;">
    <button type="button" (click)="close()"
      style="padding: 8px 18px; background: #1e5a3f; color: white; border: none; border-radius: 8px; font-weight: 600; cursor: pointer;">
      Cerrar
    </button>
  </div>
</div>
